/**
 * Client-side list search (DNKADM-0430): the toolbar search on a whole-list screen.
 *
 * A row matches when ANY of its searched fields contains the trimmed query,
 * case-insensitively. An empty (or all-space) query matches every row. Blank fields
 * never match a non-empty query.
 */
export function matchesSearch(
  query: string,
  fields: ReadonlyArray<string | null | undefined>,
): boolean {
  const needle = query.trim().toLowerCase();
  if (needle.length === 0) return true;
  return fields.some((field) => (field ?? '').toLowerCase().includes(needle));
}
